import axios from "axios";
import config from "../../config";
import { authHeader } from '../../_helpers';

export const getActivePollStatus= async()=>{    
    return axios.get(`${config.apiUrl}/poll/status`, {headers:authHeader()});
}

export const freezeActivePoll= async()=>{
    return axios.post(`${config.apiUrl}/poll/freeze`,{}, {headers:authHeader()});
}

export const unFreezeActivePoll= async()=>{
    return axios.post(`${config.apiUrl}/poll/unfreeze`,{}, {headers:authHeader()});
}

